<template>
  <div
    :class="{
      'glass-app': !isTecnicoRoute,
      'theme-light': !isTecnicoRoute && theme === 'light',
    }"
  >
    <router-view />
  </div>
</template>

<script>
import './styles/index.css'
import './styles/glass-theme.css'
import './styles/theme-light.css'
import { useTheme } from '@/composables/useTheme'

export default {
  setup() {
    const { theme } = useTheme()
    return { theme }
  },
  computed: {
    isTecnicoRoute() {
      return this.$route?.path?.startsWith('/tecnico') ?? false
    }
  }
}
</script>
<style>
</style>
